import type { LinkProps } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { useOrganisationId } from 'hooks/context';

export const OrgLink = ({ children, to, ...props }: LinkProps) => {
  const organisationId = useOrganisationId();

  const pathname = (to as string).startsWith(`/org/${organisationId}`)
    ? to
    : `/org/${organisationId}${to}`;

  return (
    <Link to={pathname} {...props}>
      {children}
    </Link>
  );
};
